import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingClone from './pages/LandingClone';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingClone />} />
      </Routes>
    </Router>
  );
}

export default App;